import React, { useEffect, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const MakeTenMatchGame = () => {
  const [cards, setCards] = useState([]);
  const [selected, setSelected] = useState([]);
  const [matchedIndexes, setMatchedIndexes] = useState([]);
  const [message, setMessage] = useState('Find pairs that add up to 10!');
  const [lockBoard, setLockBoard] = useState(false);
  const [gameOver, setGameOver] = useState(false);

  useEffect(() => {
    setupGame();
  }, []);

  const setupGame = () => {
    const numbers = generateNumbers();
    setCards(numbers);
    setSelected([]);
    setMatchedIndexes([]);
    setMessage('Find pairs that add up to 10!');
    setGameOver(false);
    setLockBoard(false);
  };

  const generateNumbers = () => {
    const pairs = [];
    for (let i = 1; i <= 4; i++) {
      pairs.push([i, 10 - i]);
    }
    pairs.push([5, 5]); // Only one [5,5] pair allowed
    shuffle(pairs);
    return shuffle(pairs.flat()).map((num, index) => ({
      value: num,
      id: index,
    }));
  };

  const shuffle = (array) => {
    let arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  const handleCardClick = (index) => {
    if (lockBoard || matchedIndexes.includes(index) || selected.some(sel => sel.index === index)) return;

    const newSelection = [...selected, { ...cards[index], index }];

    if (newSelection.length === 2) {
      setLockBoard(true);
      const [first, second] = newSelection;

      if (first.value + second.value === 10) {
        setMatchedIndexes((prev) => [...prev, first.index, second.index]);
        setMessage('🎉 Great! You found a pair!');
        if ((matchedIndexes.length + 2) === cards.length) {
          setGameOver(true);
          setMessage('🎊 You matched all pairs! Well done!');
          const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
        }
        setTimeout(() => {
          setSelected([]);
          setLockBoard(false);
        }, 500);
      } else {
        setMessage('Try again!');
        setTimeout(() => {
          setSelected([]);
          setLockBoard(false);
        }, 1000);
      }
    } else {
      setSelected(newSelection);
    }
  };

  const isSelected = (index) => selected.some((sel) => sel.index === index);
  const isMatched = (index) => matchedIndexes.includes(index);

  const styles = {
    container: {
      background: 'linear-gradient(135deg, #fceabb, #f8b500)',
      fontFamily: "'Comic Neue', cursive, sans-serif",
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '1rem',
      boxSizing: 'border-box',
      userSelect: 'none',
    },
    heading: {
      color: '#3a0ca3',
      marginBottom: '1rem',
      fontSize: '2rem',
      textAlign: 'center',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(60px, 1fr))',
      gap: '1rem',
      maxWidth: '420px',
      width: '100%',
    },
    card: {
      background: '#f72585',
      color: 'white',
      fontSize: '1.8rem',
      fontWeight: 700,
      borderRadius: '12px',
      cursor: 'pointer',
      height: '60px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
      transition: 'transform 0.3s ease, background-color 0.3s ease',
    },
    selected: {
      backgroundColor: '#720026',
      transform: 'scale(1.05)',
    },
    matched: {
      backgroundColor: '#4cc9f0',
      color: '#03045e',
      cursor: 'default',
      boxShadow: '0 0 12px 4px #90e0ef',
      pointerEvents: 'none',
    },
    message: {
      marginTop: '1.5rem',
      fontSize: '1.3rem',
      color: '#3a0ca3',
      fontWeight: 700,
      textAlign: 'center',
    },
    button: {
      marginTop: '1rem',
      padding: '0.7rem 1.5rem',
      fontSize: '1rem',
      backgroundColor: '#4361ee',
      color: 'white',
      border: 'none',
      borderRadius: '20px',
      cursor: 'pointer',
      boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Make a 10 Match Game</h1>
      <div style={styles.grid}>
        {cards.map((card, idx) => (
          <div
            key={idx}
            style={{
              ...styles.card,
              ...(isMatched(idx) ? styles.matched : {}),
              ...(isSelected(idx) ? styles.selected : {}),
            }}
            onClick={() => handleCardClick(idx)}
          >
            {card.value}
          </div>
        ))}
      </div>
      <div style={styles.message}>{message}</div>
      {gameOver && (
        <button style={styles.button} onClick={setupGame}>
          Play Again
        </button>
      )}
    </div>
  );
};

export default MakeTenMatchGame;
